import { render, staticRenderFns } from "./buy-it-again.vue?vue&type=template&id=64d4a21c&scoped=true&"
import script from "./buy-it-again.vue?vue&type=script&lang=js&"
export * from "./buy-it-again.vue?vue&type=script&lang=js&"
import style0 from "./buy-it-again.vue?vue&type=style&index=0&id=64d4a21c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d4a21c",
  null
  
)

export default component.exports